import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import HomePage from "./pages/HomePage";
import AboutPage from "./pages/AboutPage";
import VulnerabilityManagementPage from "./pages/services/VulnerabilityManagementPage";
import RiskManagementPage from "./pages/services/RiskManagementPage";
import PenetrationTestingPage from "./pages/services/PenetrationTestingPage";
import CMMCReadinessPage from "./pages/services/CMMCReadinessPage";
import PCIDSSPage from "./pages/services/PCIDSSPage";
import ThirdPartyAuditsPage from "./pages/services/ThirdPartyAuditsPage";
import { Toaster } from "./components/ui/sonner";

import Background from "./components/Background";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Background />
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/about" element={<AboutPage />} />
          <Route path="/services/vulnerability-management" element={<VulnerabilityManagementPage />} />
          <Route path="/services/risk-management" element={<RiskManagementPage />} />
          <Route path="/services/penetration-testing" element={<PenetrationTestingPage />} />
          <Route path="/services/cmmc-readiness" element={<CMMCReadinessPage />} />
          <Route path="/services/pci-dss" element={<PCIDSSPage />} />
          <Route path="/services/third-party-audits" element={<ThirdPartyAuditsPage />} />
        </Routes>
      </BrowserRouter>
      <Toaster />
    </div>
  );
}

export default App;